import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Role } from '../../../model/role';
import { RolesService } from '../../../service/component_dependent/users/roles.service';
import { PermissionService } from '../../../service/component_dependent/permission.service';
import { PermissionsListComponent } from '../../shared/permissions-list/permissions-list.component';
import { RolePermissions } from './../../../model/role-permissions';
import { NotifierService } from '../../../service/component_dependent/notifier.service';
import { JsonManager } from '../../../service/managers/json-manager';

@Component({
  selector: 'app-edit-roles',
  templateUrl: './edit-roles.component.html',
  styleUrls: ['./edit-roles.component.scss']
})
export class EditRolesComponent implements OnInit, AfterViewInit {

  public permissionsSelectedID = [];

  public role: Role;

  @ViewChild(PermissionsListComponent) permListComp: PermissionsListComponent;

  constructor(private activatedRoute: ActivatedRoute,
    private roleService: RolesService,
    private permissionService: PermissionService,
    private notifierService: NotifierService,
    private router: Router) {

    this.role = new Role();

  }

  ngOnInit() {
    this.activatedRoute.params.subscribe(
      params => {
        this.getRoleByID(params['id']);
        this.getPermissionsByRoleID(params['id']);
      }
    )
  }

  ngAfterViewInit() {

  }

  public getRoleByID(id: number) {
    this.roleService.getRole(id).subscribe(
      (data: any) => {
        this.reassignRoleProperties(data);
      }
    )
  }

  private reassignRoleProperties(data) {
    this.role.id = data.data.id;
    this.role.name = data.data.name;
    this.role.display_name = data.data.display_name;
    this.role.description = data.data.description;
  }

  private getPermissionsByRoleID(id: number) {
    this.roleService.getRolePermissionsByRoleID(id).subscribe(
      (data: any) => {
        this.reassignPermissionSelectedArr(data);
      }
    );
  }

  private reassignPermissionSelectedArr(data) {
    for (var i = 0; i < data.data.length; i++) {
      this.permissionsSelectedID.push(data.data[i].id);
    }

    this.permListComp.permissionsSelectedID = this.permissionsSelectedID;
    for (var i = 0; i < this.permissionsSelectedID.length; i++) {
      this.permListComp.viewGrantedPermissionHandler("add", this.permissionsSelectedID[i]);
    }
  }


  public saveAndInsert() {
    this.onSubmit("SAI");
  }

  public saveAndExit() {
    this.onSubmit("SAE");
  }

  private onSubmit(mode: string) {

    let rolePermissions = new RolePermissions();

    this.roleService.updateRole(this.role).subscribe(
      (data: any) => {
        rolePermissions.roleID = this.role.id;
        rolePermissions.permissionsID = this.permissionsSelectedID;
        this.roleService.storeRolePermissions(rolePermissions).subscribe(
          (dataB: any) => {
            if (mode == "SAE") {
              this.exit();
            } else if (mode == "SAI") {
              this.clearRegistrationForm();
            }
            this.notifierService.showSuccess(data.message);
          }, (error: any) => {
            this.notifierService.showError(JsonManager.getBreakLineSeparatedErrorMessages(error.error.message));
          },
        )
      }, (error: any) => {
        this.notifierService.showError(JsonManager.getBreakLineSeparatedErrorMessages(error.error.message));
      },
    )
  }

  private clearRegistrationForm() {
    this.permListComp.clearAll();
    this.permissionsSelectedID = [];
    this.role = new Role();
    document.forms['roleForm'].reset();
  }

  private exit() {
    this.router.navigateByUrl("/joytogive/roles");
  }

  private clear() {
    this.permListComp.clearAll();
  }
}
